import { createPostMessage, HandshakeAckRejectedError } from "@connect/post-message/client";
import type { ResetMessageMap } from "@connect/post-message/protocol";
import { initializeStore } from "@connect/credentials-storage";
import { resolveCredentialsEnvironment } from "../../lib/parse-frame-config.ts";
import { log } from "@connect/observability";
import { stampFramesVersion } from "../../lib/frames-version.ts";
import { enableMocking } from "../../lib/enable-mocking.ts";
import { setupObservability } from "../../lib/observability-setup.ts";
import { trackWidgetVisited } from "../../lib/use-widget-visited.ts";
import { reportFrameInitFailure } from "../../utils/report-frame-init-failure.ts";
import { parseConfig } from "./config.ts";
import { reset } from "./reset.ts";

stampFramesVersion();

initializeStore(resolveCredentialsEnvironment());

const params = new URLSearchParams(window.location.search);
setupObservability({
  frame: "reset",
  getClientToken: () => params.get("clientToken") || undefined,
});

try {
  await enableMocking();
} catch {}

const config = parseConfig();
trackWidgetVisited("reset");

try {
  const pm = createPostMessage<ResetMessageMap>({
    channelId: config.channelId,
    ...(config.clientToken && { clientToken: config.clientToken }),
  });
  await pm.connected;
  await reset(config);
} catch (err) {
  // A rejected ack already sent its own specific error to the parent (see
  // listenForParent's origin check) -- log it, but don't send the generic
  // fallback too and duplicate the signal.
  if (err instanceof HandshakeAckRejectedError) {
    log.error(err);
  } else {
    await reportFrameInitFailure(config.channelId, err);
  }
}
